
import VendorCreate from '../components/views/vendor/vendorCreate.vue'
import Vendor from '../components/views/vendor/vendor.vue'

const routes = [
    {
        path: 'vendor',
        component: Vendor,
        name: 'vendor',
        meta: {
            description: 'List of Vendors',
            title: 'Vendor',
            requiresAuth: true
        }
    },
    {
        path: 'vendor/vendorCreate/:_id',
        component: VendorCreate,
        name: 'vendorCreate',
        meta: {
            title: 'Add / Update Vendor',
            requiresAuth: true
        }
    },
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/vendor.route.js